import React, { Component } from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import { grey50 } from 'material-ui/styles/colors';
import gql from 'graphql-tag';
import { Mutation } from 'react-apollo';

import './bookButton.css';
import styles from '../../../styles.js';

const CREATE_BOOKINGS = gql`
  mutation createBookings($selectedShifts: [BookingAttributes!]!) {
    createBookings(shifts: $selectedShifts) {
      bookings {
        startTime
        endTime
        vehicleClass
        id
      }
      errors {
        message
        startTime
        endTime
      }
    }
  }
`;
class BookButton extends Component {
  constructor(props) {
    super(props);
    this.state = { disabled: false };
  }

  render() {
    const {
      selectedShifts = [],
      openDialog,
      clearSelectedShifts,
      refetchBookings
    } = this.props;

    return (
      <Mutation
        mutation={CREATE_BOOKINGS}
        onCompleted={async ({ createBookings }) => {
          await openDialog('book', createBookings);
          await this.setState({ disabled: false });
          await clearSelectedShifts();
          await refetchBookings();
        }}>
        {createBookings => (
          <RaisedButton
            id="book-button"
            backgroundColor="#33691E"
            display="block"
            disabled={this.state.disabled}
            fullWidth={false}
            label={
              this.state.disabled ? (
                <i className="spinner fa fa-spinner fa-spin" />
              ) : (
                'Book'
              )
            }
            labelColor={grey50}
            labelStyle={{ fontFamily: 'Montserrat', fontWeight: '200' }}
            onClick={() => {
              this.setState({ disabled: true });
              createBookings({ variables: { selectedShifts } });
            }}
            style={styles.RaisedBtnLrgMui}
          />
        )}
      </Mutation>
    );
  }
}

export default BookButton;



// WEBPACK FOOTER //
// ./src/components/Book/SelectedShifts/BookButton.js